import * as PIXI from "pixi.js";

import { assetManifest } from "@src/game/assets/AssetImports";
import { EventSystem } from "@src/core/events/EventSystem";
import { Assets } from "@src/core/assets/Assets";
import { constants } from "@src/game/Constants";

type TUIAssetAlias = keyof typeof assetManifest &
  (`${string}UI${string}` | `UI${string}`);

// This class represents the labeled info sections on the game UI (i.e. Balance 1000)
export class TitledInfo {
  private _view: PIXI.Container = new PIXI.Container();
  public get view(): PIXI.Container {
    return this._view;
  }

  private _background: PIXI.Sprite = new PIXI.Sprite();
  private _titleText: PIXI.Text = new PIXI.Text();
  private _infoText: PIXI.Text = new PIXI.Text();
  private _title: string;
  private _text: string;

  public constructor(title: string, text: string) {
    this._title = title;
    this._text = text;

    this._setupEventListeners();
    this._initializeAssets();
    this._parentAssets();
  }

  public setInfoText(text: string): void {
    this._infoText.text = text;
  }

  private _setupEventListeners(): void {
    EventSystem.addListener(
      constants.GameEvents.LANDSCAPE_LAYOUT_REQUESTED,
      this._onLandscapeLayoutRequested.bind(this),
    );

    EventSystem.addListener(
      constants.GameEvents.PORTRAIT_LAYOUT_REQUESTED,
      this._onPortraitLayoutRequested.bind(this),
    );
  }

  private _initializeAssets(): void {
    const atlasUI = Assets.getAsset<TUIAssetAlias>("atlasUI");

    this._background = new PIXI.Sprite(
      atlasUI.textures["amountBackground.webp"],
    );
    this._background.anchor.set(0.5);
    this._background.position.set(0, 0);

    this._titleText = new PIXI.Text({
      text: this._title,
      style: {
        fill: "0xffffff",
        fontWeight: "bold",
        fontFamily: "uiFont",
        stroke: {
          color: "0x000000",
          width: 2,
        },
      },
    });
    this._titleText.style.align = "center";

    this._infoText = new PIXI.Text({
      text: this._text,
      style: {
        fill: "0xffffff",
        fontWeight: "bold",
        fontFamily: "uiFont",
        stroke: {
          color: "0x000000",
          width: 2,
        },
      },
    });
    this._infoText.anchor.set(0.5);
    this._infoText.style.align = "center";
  }

  private _parentAssets(): void {
    this._view.addChild(this._background);
    this._view.addChild(this._titleText);
    this._view.addChild(this._infoText);
  }

  private _onLandscapeLayoutRequested(): void {
    const landscapeSpacing: number = 20;

    this._infoText.style.fontSize = 28;
    this._background.scale.set(0.7);

    this._titleText.style.fontSize = 28;
    this._titleText.anchor.set(0, 0.5);
    this._titleText.position.set(
      -this._titleText.width - this._background.width / 2 - landscapeSpacing,
      0,
    );
  }

  private _onPortraitLayoutRequested(): void {
    this._infoText.style.fontSize = 40;
    this._background.scale.set(1);

    this._titleText.style.fontSize = 40;
    this._titleText.anchor.set(0.5);
    this._titleText.position.set(0, -65);
  }
}
